function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "giropay",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-15",
  fill: "#0F4CA1",
  x: 0,
  y: 0,
  width: 32,
  height: 32,
  rx: 8
}), /*#__PURE__*/React.createElement("path", {
  d: "M17,23 L20,23 L20,18.0490243 C20.5814393,19.1337736 21.8549312,19.5355988 22.9316707,19.5355988 C25.5813229,19.5355988 27,17.2960492 27,14.6013162 C27,12.3972392 25.6505835,10 23.1886331,10 C21.7868347,10 20.6151966,10.5774002 20,11.8547156 L20,10 L17,10 L17,23 Z M23.8209993,14.6716654 C23.8209993,16.1242576 23.1199546,17.1210704 21.95824,17.1210704 C20.9321363,17.1210704 20.0765649,16.1242576 20.0765649,14.7938823 C20.0765649,13.4295247 20.8294095,12.4145284 21.95824,12.4145284 C23.1542939,12.4145284 23.8209993,13.463805 23.8209993,14.6716654 Z",
  id: "Fill-6-Copy-4",
  fill: "#FFFFFE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15,10.2065122 L12.1744262,10.2065122 L12.1744262,11.824582 L12.1404968,11.824582 C11.4816782,10.7230859 10.4068567,10 9.07269723,10 C6.26541571,10 5,11.9967732 5,14.6658844 C5,17.3185685 6.54245589,19.1765914 9.02106568,19.1765914 C10.2687791,19.1765914 11.3084912,18.6958052 12.0531658,17.6441772 L12.0882752,17.6441772 L12.0882752,18.1273101 C12.0882752,19.8835436 11.118192,20.7268994 9.31551307,20.7268994 C8.01557798,20.7268994 7.21838674,20.4517454 6.26541571,19.9867996 L6.10904585,22.4320915 C6.83719832,22.6893517 8.06779961,23 9.55803387,23 C13.1976161,23 15,21.8113816 15,18.1273101 L15,10.2065122 Z M8.22357939,14.613963 C8.22357939,13.3919038 8.83017643,12.3760634 9.99144391,12.3760634 C11.3949372,12.3760634 11.984422,13.4942798 11.984422,14.4933998 C11.984422,15.8715166 11.1001947,16.8011147 9.99144391,16.8011147 C9.05558506,16.8011147 8.22357939,16.0082136 8.22357939,14.613963 Z",
  id: "Fill-9-Copy-3",
  fill: "#FFFFFE"
}));

var SvgGiropay = function SvgGiropay(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGiropay, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/giropay.edfe3584.svg";
export { ForwardRef as ReactComponent };